export enum LabelBadgeSizeType {
  Size16 = 'size16',
  Size18 = 'size18',
  Size28 = 'size28',
}
